<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>{{ 'Dashboard.VotingMonitor' | translate }}</mat-card-title>
        <div class="widget-action-buttons align-items-start" slHideIfDashboardEditMode>
            <mat-icon color="primary">online_prediction</mat-icon>
        </div>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <sl-auto-complete
                        placeholderKey="VotingMonitor.AgendaItems"
                        [items]="agendaItems"
                        (select)="selectItem($event)"
                        (clear)="selectItem()"
                        [defaultSelectedId]="currentItemNumber" />
                </div>
            </div>
            <br />
            @for (vote of currentVoting; track vote) {
                <div class="row">
                    <div class="col-8">
                        {{ vote.displayName }}
                        <br />
                        <small>{{ vote.votes | slNumber }}</small>
                    </div>
                    <div class="col-4">
                        <div class="ml-1">
                            <div>
                                @switch (vote.optionsNumber) {
                                    @case (VoteOptionEnum.NoVote) {
                                        <span class="danger">{{ vote.voteDescription }}</span>
                                    }
                                    @case (VoteOptionEnum.Yes) {
                                        <mat-icon color="primary">check</mat-icon>
                                    }
                                    @case (VoteOptionEnum.No) {
                                        <mat-icon color="danger">close</mat-icon>
                                    }
                                    @case (VoteOptionEnum.Abstention) {
                                        <mat-icon class="absention">remove</mat-icon>
                                    }
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </mat-card-content>
</mat-card>
